import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import viewMixin from '../../components/core/consumers/viewMixin';
export default {
  name: 'ViewConnectorsList',
  mixins: [viewMixin],
  data: function data() {
    return {
      showCreateDialog: false,
      connector: {},
      accounts: [],
      loadingAccounts: true,
      selectedAccounts: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['color'])), mapState('authentication', ['tenantId'])), {}, {
    isLoadingAccounts: function isLoadingAccounts() {
      // combine loading states into one
      return this.loadingAccounts;
    }
  }),
  watch: {
    selectedAccounts: function selectedAccounts() {
      this.fetchTransformers(this.selectedAccounts);
    }
  },
  created: function created() {
    this.fetchAccounts();
  },
  methods: {
    closeCreateDialog: function closeCreateDialog() {
      var reloadList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (reloadList) {
        this.$refs['bridges'].loadData();
      }

      this.showCreateDialog = false;
    },
    handleShowCreateDialog: function handleShowCreateDialog() {
      this.$refs.bridges.showCreateDialog();
    },
    fetchAccounts: function fetchAccounts() {
      var _this = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this.accounts = accounts;
      }).catch(function (error) {
        console.error(error);

        _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    }
  }
};